import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { EmptyState, PageHeader } from '@koyomi/ui';

const titles: Record<string, string> = { agenda: 'nav:main.agenda', conversations: 'nav:main.conversations', waitlist: 'nav:main.waitlist', clients: 'nav:main.clients', reports: 'nav:main.reports', audit: 'nav:main.audit' };

/** Páginas das próximas fases. Mantém a navegação e o layout funcionando desde a fase 1. */
export function PlaceholderPage({ pageKey }: { pageKey: string }) {
  const { t } = useTranslation(['nav', 'common']);
  const { section } = useParams();
  const title = pageKey === 'config' ? (section ?? '') : t(titles[pageKey] ?? pageKey);
  return (
    <>
      <PageHeader title={title} />
      <EmptyState title={t('common:status.empty')} description={t('common:status.wip')} />
    </>
  );
}
